<template>
  <v-row justify="center">
    <v-col v-for="(item, index) in homeworks" :key="item.uuid" cols="12">
      <app-homework-details :item="item" :index="index" @homework-deleted="onDeleted" />
    </v-col>
    <v-col cols="12" class="text-center">
      <v-btn
        v-if="profile.role === 'TEACHER'"
        :loading="loading"
        class="rounded-lg text-capitalize white--text"
        depressed
        color="#29284c"
        @click="dialog = true"
      >
        Add Custom Homework
      </v-btn>
    </v-col>
    <app-create-homework-dialog
      v-model="dialog"
      max-width="800"
      :location="location"
      :loadingAssign="loadingAssign"
      :createFields="createFields"
      @new-homework="onNewHomework"
    />
  </v-row>
</template>
<script>
import { getHomeworks, assignHomework } from "@/api/api";
import HomeworkDetails from "./HomeworkDetails.vue";
import CreateHomeworkDialog from "./CreateHomeworkDialog.vue";
import studentMixin from "@/mixins/studentMixin";

export default {
  components: {
    appHomeworkDetails: HomeworkDetails,
    appCreateHomeworkDialog: CreateHomeworkDialog,
  },
  mixins: [studentMixin],
  props: {
    filterFields: { type: Object, default: () => ({}) },
    createFields: { type: Object, default: () => ({}) },
    active: Boolean,
  },
  data() {
    return {
      homeworks: [],
      dialog: false,
      loading: false,
      loadingAssign: false,
    };
  },
  computed: {
    direction() {
      if (this.$route.name === "practice") {
        return "practice";
      } else return "teach";
    },
    profile() {
      return this.$store.getters.profile;
    },
    location() {
      if (this.direction === "practice") {
        return "PRACTICE";
      }
      return "LIVE";
    },
  },
  methods: {
    onDeleted(uuid) {
      const index = this.homeworks.findIndex((item) => item.uuid === uuid);
      if (index > -1) {
        this.homeworks.splice(index, 1);
      }
    },
    async onNewHomework(homework) {
      try {
        this.loadingAssign = true;
        await assignHomework({
          homework: homework.uuid,
          student: this.student.email,
        });
        this.dialog = false;
        const newHomework = {
          ...homework,
          students: [
            {
              email: this.student.email,
              uuid: this.student.uuid,
            },
          ],
        };
        this.homeworks.push(newHomework);
      } finally {
        this.loadingAssign = false;
      }
    },
    async fetchHomeworks() {
      const params = {
        teacher_lesson__uuid: this.$store.getters["lesson/teacher_lesson"].uuid,
        location: this.location,
        students__student__email: this.student.email,
        ...this.filterFields,
      };
      if (!Object.keys(this.filterFields).length) {
        params.not_speak = true;
      }
      if (this.profile.role === "TEACHER") {
        params.teacher__email = this.profile.email;
      }
      const customs = await getHomeworks({
        ...params,
        type: "Custom",
      });
      this.homeworks = customs.data.results;
    },
  },
  watch: {
    active(v) {
      if (v) {
        this.fetchHomeworks();
      }
    },
  },
  mounted() {
    this.fetchHomeworks();
  },
};
</script>
